// extracted by mini-css-extract-plugin
export var alignCenter = "_9p-d";
export var bannerShown = "_9p-6";
export var buttonContent = "_9p-0";
export var cardList = "_9p-1";
export var centerContent = "_9p-2";
export var chevron = "_9p-3";
export var closePanelButton = "_9p-k";
export var conversationContextContainer = "_9p-l";
export var conversationDetailContainer = "_9p-4";
export var detailWrapper = "_9p-7";
export var dropdownButton = "_9p-e";
export var dropdownTitle = "_9p-9";
export var fullHeight = "_9p-5";
export var hidden = "_9p-a";
export var icon = "_9p-b";
export var mergeSuggestionWrapper = "_9p-m";
export var panel = "_9p-i";
export var portalButtonsWrapper = "_9p-c";
export var right = "_9p-j";
export var tableSummaryContainer = "_9p-8";
export var tableSummaryHeader = "_9p-g";
export var threeDotsButton = "_9p-f";
export var wide = "_9p-h";